import React, { useEffect } from "react";
import Header from "../../components/header/header";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { CUSTOM_SELECT_STYLES, PAGES, PAGES_NAME, SELECT_BOX_THEME } from "../../constants";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { RoutesPaths } from "../../Router/constant";
import { addTermsAndPrivacy, getTermsAndPrivacy } from "../../actions/termsAndPrivacy";

export default function AddTermsAndPrivacy() {
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const type = state?.type;

  const { singleTermsAndPrivacy } = useSelector((state) => state.termsAndPrivacy);

  useEffect(() => {
    if (type) {
      dispatch(getTermsAndPrivacy(type));
    }
  }, [type, watch])

  useEffect(() => {
    if (singleTermsAndPrivacy) {
      setValue("type", parseInt(singleTermsAndPrivacy?.type) === PAGES.PRIVACYPOLICY ? { label: "Privacy policy", value: 1 } : { label: "Terms and Conditions", value: 2 })
      setValue("content", singleTermsAndPrivacy?.content)
    }
  }, [setValue, singleTermsAndPrivacy])


  const onCancel = () => {
    navigate(RoutesPaths.TERMSANDPRIVACY);
    reset()
  }
  const onSubmit = async (data) => {
    data.type = data?.type?.value
    await dispatch(addTermsAndPrivacy(data))
    reset()
    navigate(RoutesPaths.TERMSANDPRIVACY)
  }
  return (
    <>
      <Header title="Objective" />
      <div className="container-fluid py-4 addPlanPage">
        <div className="row">

          <div className="col-lg-8 col-xl-8 col-md-8 col-sm-12 mb-2">
            <div className="planSegments">
              <div className="segment">
                {/* <p>{id ? "Edit objective" : "Create new objective"}</p> */}
              </div>
            </div>
            <form className="addQuillEditor">
              <div className="planProfileCard">
                <div className="form-group form-margin">
                  <div className="row">
                    <div className="col-4 fieldPadding">
                      <p className="input-text heading">
                        Select page type
                      </p>
                      <Controller
                        name="type"
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: "Select page type",
                          },
                        }}
                        // defaultValue={null}
                        render={({ field }) => (
                          <Select
                            theme={SELECT_BOX_THEME}
                            styles={CUSTOM_SELECT_STYLES}
                            className="select-border"
                            {...field}
                            options={PAGES_NAME}
                            isClearable={true}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            placeholder="Select page type"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                          />
                        )}
                      />
                    </div>
                    {watch("type") &&
                      <div className="col-lg-12 fieldPadding">
                        <p className="input-text heading">
                          {watch("type")?.value === PAGES.PRIVACYPOLICY ? "Privacy policy" : "Terms and conditions"}
                        </p>
                        <Controller
                          name="content"
                          control={control}
                          rules={{
                            required: {
                              value: true,
                              message: "Select content",
                            },
                          }}
                          render={({ field }) => (
                            <ReactQuill
                              className="editor"
                              theme="snow"
                              {...field}
                            />
                          )}
                        />
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div className="buttonSection">
                <button
                  onClick={onCancel}
                  type="button"
                  className="btn save-btn cancel"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  onClick={handleSubmit(onSubmit)}
                  className="btn agree-button save-btn"
                >
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
